export const AUTH_TOKEN_COOKIE_NAME = 'token';
